"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createApp;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

require("core-js/modules/es6.promise");

var _native = require("../native");

var _web = require("../web");

var _utils = _interopRequireDefault(require("../utils"));

var _config = require("../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } } function _next(value) { step("next", value); } function _throw(err) { step("throw", err); } _next(); }); }; }

var device = _utils.default.device,
    urlParams = _utils.default.urlParams,
    getENV = _utils.default.getENV;

function addScript(id, url) {
  return new Promise(function (resolve) {
    var script = document.getElementById(id);

    if (!script) {
      script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = id;
      script.src = url;
      document.body.appendChild(script);

      script.onload = function () {
        resolve();
      };
    } else {
      resolve();
    }
  });
}

function addQRCode() {
  return _addQRCode.apply(this, arguments);
}
/**
 * 初始化
 * 入参:
 *  {Boolean} isDebug：是否开启调试
 *  {Boolean} openInApp：是否在app内打开
 *  {Array} apiList：需要授权的api
 *  {Object} config
 *    {Boolean} closeTips：是否toast错误
 */


function _addQRCode() {
  _addQRCode = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    var url, commonUrl, divCon, divTip, divCode;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return addScript('QRCodeUrl', _config.UTILS.QRCodeUrl);

          case 2:
            url = window.location.href;
            commonUrl = "".concat(_config.ROUTE.web, "?url=").concat(encodeURIComponent(url));
            divCon = document.createElement('div');
            divTip = document.createElement('div');
            divCode = document.createElement('div');
            divCon.style = "text-align:center;font-size:18px;padding:30px 0;\n      position: fixed;top: 0;left: 0;right: 0;bottom: 0;background: #fff;z-index: 9999;";
            divTip.innerText = '请使用app扫一扫打开';
            divTip.style = 'margin-bottom:20px;';
            divCode.style = 'display: inline-block;';
            document.body.appendChild(divCon);
            divCon.appendChild(divTip);
            divCon.appendChild(divCode);
            new window.QRCode(divCode, commonUrl);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _addQRCode.apply(this, arguments);
}

function createApp() {
  return _createApp.apply(this, arguments);
}

function _createApp() {
  _createApp = _asyncToGenerator(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2() {
    var opts,
        openInApp,
        _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            opts = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            openInApp = opts.openInApp || false;

            if (!(openInApp && !device && urlParams.isApp !== '0')) {
              _context2.next = 6;
              break;
            }

            _context2.next = 5;
            return addQRCode();

          case 5:
            return _context2.abrupt("return", Promise.reject('use device toolbar'));

          case 6:
            if (getENV() === 'PROD' && urlParams.isDebug !== '1') {
              opts.isDebug = false;

              console.log = function () {};
            } // 打开vconsole


            if (!opts.isDebug) {
              _context2.next = 11;
              break;
            }

            _context2.next = 10;
            return addScript('vconsoleUrl', _config.UTILS.vconsoleUrl);

          case 10:
            new window.VConsole({
              maxLogNumber: 5000
            });

          case 11:
            window.WLSDK = {}; // 如果在app打开则执行native

            if (!openInApp) {
              _context2.next = 14;
              break;
            }

            return _context2.abrupt("return", (0, _native.native)(opts));

          case 14:
            return _context2.abrupt("return", (0, _web.web)(opts));

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _createApp.apply(this, arguments);
}